
import Form from "./Form.vue";

export default {
  name: "app-contratos-create",
  data() {
    return {};
  },
  components: {
    Form,
  },
  mounted() {},
};
